import { render, staticRenderFns } from "./saveBusinessKeyWord.vue?vue&type=template&id=4bda5bba"
import script from "./saveBusinessKeyWord.vue?vue&type=script&lang=js"
export * from "./saveBusinessKeyWord.vue?vue&type=script&lang=js"
import style0 from "./saveBusinessKeyWord.vue?vue&type=style&index=0&id=4bda5bba&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports